export const CTA_ID = 'plan_selector';



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/constants.js